<template>
  <v-container
    id="Mass Upload"
    fluid
    tag="section"
  >
    <div
        align="end"
    >
    <v-btn
        v-if="titleTxt == 'GFK' && (massuploadRole == 1 || massuploadRole == 2)"
        x-large
        elevation="10"
        tile
        depressed
        color="green"
        to="/op/tables/massupload"
    >
        To NIQ
    </v-btn>
    <v-btn
        v-if="titleTxt == 'NIQ' && (massuploadCiRole == 1 || massuploadCiRole == 2)"
        x-large
        elevation="10"
        tile
        depressed
        color="green"
        to="/op/tables/ci-massupload"
    >
        To GFK
    </v-btn>
    <v-btn
        v-if="massuploadRole == 1 && myDB == 'international'"
        x-large
        elevation="10"
        tile
        depressed
        color="success"
        to="/op/tables/massuploadAccess"
    >
        Access Control
    </v-btn>
    <v-btn
        v-if="massuploadCiRole == 1 && myDB == 'ci'"
        x-large
        elevation="10"
        tile
        depressed
        color="success"
        to="/op/tables/ci-massuploadAccess"
    >
        Access Control
    </v-btn>
    <v-btn
        x-large
        elevation="10"
        tile
        depressed
        color="red"
        to="/"
    >
        Back To Main
    </v-btn>
    </div>
    <h1
        class="font-weight-light mb-2 text-center text-h2"
    >
        {{ titleTxt }}
    </h1>
    <base-material-card
        icon="mdi-account-settings"
        inline
        class="px-5 py-3"
        min-height="230"
    >
        <template v-slot:after-heading>
        <div class="text-h3 font-weight-light">
            Mass Upload
        </div>
        </template>
        <template v-slot:after-heading-right>
            <form method="post" enctype="multipart/form-data" style="display:none">
                <!-- upload of a single file -->
                <p>
                    <label>Add file (single): </label><br/>
                    <input 
                        type="file" 
                        name="upload" 
                        id="select_file" 
                        ref="select_file"
                        multiple="false"
                        @change="handle_file_change"
                    />
                </p>
                <p>
                    <input 
                        type="submit" 
                        id="submit_file" 
                        ref="submit_file" 
                    />
                </p>
            </form>
            <v-btn
                color="primary"
                class="ma-0"
                :loading="uploading"
                :disable="uploading"
                @click="select_file"
            >
                1. Analyse File
            </v-btn>
            <v-btn
                v-if="verified"
                color="error ml-5"
                class="ma-0"
                :loading="uploading"
                :disable="uploading"
                @click="merge_DB"
            >
                2. CONFIRM AND UPLOAD
            </v-btn>
        </template>
        <v-textarea
          outlined
          no-resize
          rows="20"
          readonly
          disable
          name="outputbox"
          label="Message Window"
          :value="outputbox"
          class="mt-5"
        ></v-textarea>
    </base-material-card>
    <base-material-card
        icon="mdi-account-details-outline"
        inline
        class="px-5 py-3 mt-15"
        min-height="230"
    >
        <template v-slot:after-heading>
            <div class="text-h3 font-weight-light">
                Mass Upload History
            </div>
        </template>
        <template v-slot:after-heading-right>
            <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto"
                label="Search"
                hide-details
                single-line
                style="max-width: 320px;"
                @input="reload()"
            />
        </template>
        <v-data-table
            class="mt-4"
            :headers="headers"
            :items="historyData"
            :loading="!isLoaded"
            :search="search"
            :items-per-page="10"
        >
            <template v-slot:item.user="{ item }">
                <poptip-profile
                    :useremail="item.user.useremail"
                    :username="item.user.fullName"
                    :gid="item.user.gid"
                    :url="item.user.icon"
                    :avatarsize="22"
                    :textsize="12"
                />
            </template>
        </v-data-table>
    </base-material-card>
  </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import { xPost } from '@/http/axios/index.js'
  import { xPostMassupload, xUploadMassupload } from '@/http/axios/index.js'
  export default {
    components: {
      PoptipProfile: () => import('@/components/poptip-profile-v2')
    },
    data () {
        return {
            myDom: {
                params: {},
            },
            titleTxt: '',
            massuploadRole: false,
            massuploadCiRole: false,
            uploading: false,
            outputbox: 'This is a message window.',
            verified: false,
            file: null,
            headers: [
                {
                    text: 'Country',
                    value: 'country',
                    width: 200,
                    sortable: true
                },
                {
                    text: 'Upload ID',
                    value: 'comment',
                    width: 200,
                    sortable: true
                },
                {
                    text: 'Uploader',
                    value: 'user',
                    width: 200,
                    sortable: true
                },
                {
                    text: 'Time',
                    value: 'timestamp',
                    width: 1,
                    sortable: true
                }
            ],
            historyData: [],
            isLoaded: false,
            search: null
        }
    },
    computed: {
        ...mapState([
            'gapi',
            'user'
        ]),
        myDB () {
            return this.lodash.get(this.myDom, ['params', 'db']) || ''
        },
    },
    beforeMount () {
        this.init()
    },
    beforeDestroy() {
        // console.log('----页面销毁监听事件----')
        // this.$eventBus.$off("check-access")
        // this.$eventBus.$off("complete_check_access")
    },
    methods: {
        async init () {
            this.myDom.params = this.$route.meta instanceof Object ? this.$route.meta : {}
            // this.$eventBus.$emit('check-access')
            // this.$eventBus.$emit('complete_check_access', this.stopLoading)
            // if (this.user.Role == 1) {
            //     await this.GetData()
            // }
            await this.getRole()
            await this.GetData()
        },

        async GetData () {
            this.isLoaded = false
            
            if (this.myDB === 'international') {
                this.titleTxt = 'NIQ'
            } else if (this.myDB === 'ci') {
                this.titleTxt = 'GFK'
            }
            try {
                let point
                if (this.myDB === 'international') {
                    point = 'massupload'
                }
                else if (this.myDB === 'ci') {
                    point = 'ci_massupload'
                }
                const req = xPostMassupload(
                    point,
                    'getHistory',
                    {
                    userinfo: this.user
                    })
                const res = await req
                if (res.status === 200 && res.data.status === 200) {
                    this.historyData = res.data.history.map(el => ({
                        user: {
                            useremail: el.user,
                            gid: el.Gg_Id,
                            fullName: el.Name,
                            icon: el.Avatar
                        },
                        country: el.country,
                        timestamp: el.refresh_time,
                        comment: el.comment
                    }))
                    // console.log(this.historyData)
                }
            } catch (err) {
                console.log(err)
                this.snackbarMessage = "can't get user info"
                this.snackbar = true
                this.snackbarColor = 'error'
                // this.confirmUploading = false
            }
            this.reload()
            this.isLoaded = true
        },
        reload() {

        },
        // whether setting changed and set the param as the setting changed
        select_file(){
            this.$refs["select_file"].click()
        },
        handle_file_change(e){
            const files = e.target.files
            if (!files) {
                return
            }
            this.upload_files(files[0])
        },
        async upload_files(files){
            this.uploading = true
            try {
                this.file = files
                this.outputbox = 'Analysing the file...\n\r'
                let formData = new FormData()
                formData.append('file', files)
                formData.append('userinfo', JSON.stringify(this.user));
                let point
                if (this.myDB === 'international') {
                    point = 'massupload'
                }
                else if (this.myDB === 'ci') {
                    point = 'ci_massupload'
                }
                const res = await xUploadMassupload(point, 'upload', formData)
                const response = res.data
                this.outputbox = ''
                this.outputbox += response.message;

                if (response.content == 'successed') {
                    this.verified = true
                }
                if (response.content == 'failed') {
                    this.verified = false
                    this.$refs.select_file.value = null
                }
            } catch (err) {
                console.log(err)
            }
            this.uploading = false
        },
        async merge_DB() {
            this.uploading = true
            if (this.file == null) {
                this.outputbox = 'File didn\'t get uploaded...\n\r'
                this.uploading = false
            }
            
            try {
                this.outputbox += 'Merging the file with DB...\n'
                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('userinfo', JSON.stringify(this.user));
                let point
                if (this.myDB === 'international') {
                    point = 'massupload'
                }
                else if (this.myDB === 'ci') {
                    point = 'ci_massupload'
                }
                const res = await xUploadMassupload(point, 'merge', formData)
                const response = res.data
                if (typeof(response.message) !== 'undefined') {
                    this.outputbox += response.message
                } else {                
                    this.outputbox += response
                }
                

                if (response.content == 'successed') {
                    this.verified = false
                    this.$refs.select_file.value = null
                }
                if (response.content == 'failed') {
                    this.verified = false
                    this.$refs.select_file.value = null
                }
            } catch (err) {
                console.log(err)
            }
            this.GetData()
            this.uploading = false
        },
        async getRole() {
            const params = {
                useremail: this.user.email
            }
            try {
                const res = await xPost(
                'massuploadaccess',
                'massuploadRole',
                params
                )
                if (res.status === 200 && (res.data.massuploadRole || res.data.massuploadCiRole)) {
                    this.massuploadRole = res.data.massuploadRole.Role || []
                    this.massuploadCiRole = res.data.massuploadCiRole.Role || []
                    this.massuploadMaintain = res.data.massuploadMaintain || 1
                }
            } catch (err) {
                console.log("can't get user Role")
                console.log(err)
            }
            if (this.myDB === 'international' && this.massuploadRole != 1 && this.massuploadRole != 2) {
                window.location.href= '/';
            }
            // console.log(this.myDB)
            // console.log(this.massuploadRole)
            // console.log(this.massuploadCiRole)
            if (this.myDB === 'ci' && this.massuploadCiRole != 1 && this.massuploadCiRole != 2) {
                window.location.href= '/';
            }
            if (this.massuploadMaintain != 0) {
                window.location.href= '/';
            }
        },
    },
  }
</script>
